<template>
    <div>
        <h1>포인트 내역</h1>

        <section class="mt-4">
            <example-layout class="overflow-auto mt-8">
                <template v-slot:render>
                    <example-point-history />
                </template>
                
                <template v-slot:editor>
                    <prism-editor v-model="section1.exampleCode" line-numbers class="rounded"></prism-editor>
                </template>
            </example-layout>
        </section>
    </div>
</template>

<script>
import exampleLayout from '@/components/developer/example-layout.vue'
import prismEditor from '@/components/developer/prism-editor.vue'

import examplePointHistory from '@/components/developer/me/example-point-history.vue'

export default {
    components: {
        exampleLayout,
        prismEditor,

        examplePointHistory
    },
    data(){
        return {
            section1: {
                exampleCode: `<template>\n    <div>\n        <v-select v-model=\"filter.type\" :items=\"types\" item-text=\"text\" item-value=\"value\" label=\"검색 타입\" dense hide-details outlined class=\"d-inline-block\" @input=\"page = 1, search()\" />\n\n        <table width=\"100%\" class=\"mt-4\">\n            <thead>\n                <tr>\n                    <th>날짜</th>\n                    <th>타입</th>\n                    <th>비고</th>\n                    <th>이용금액</th>\n                    <th>남은잔액</th>\n                </tr>\n            </thead>\n            <tbody>\n                <template v-for=\"point, index in points\">\n                    <tr :key=\"index\">\n                        <td>{{ $dayjs(point.createdAt).format(\"YYYY-MM-DD HH:mm:ss\") }}</td>\n                        <td>{{ point.type }}</td>\n                        <td>{{ point.remark }}</td>\n                        <td>{{ point.amount.format() }}</td>\n                        <td>{{ point.remain.format() }}</td>\n                    </tr>\n                </template>\n            </tbody>\n        </table>\n\n        <v-pagination v-model=\"page\" :length=\"pageCount\" total-visible=\"11\" @input=\"search()\" class=\"mt-4\"/>\n    </div>\n</template>\n\n<script>\nimport api from \"@/api\";\n\nexport default {\n    data(){\n        return {\n            filter: {\n                type: null\n            },\n\n            page: 1,\n            pageCount: 0,\n            limit: 10,\n\n            summary: { totalCount: 0 },\n            points: [],\n\n            types: [\n                { text: \":: 전체 ::\", value: null },\n                { text: \"충전\", value: \"charge\" },\n                { text: \"사용\", value: \"use\" },\n            ]\n        }\n    },\n    mounted(){\n        this.search();\n    },\n    methods: {\n        async search(){\n            let { summary, points } = await api.v1.me.points.gets({\n                headers: {\n                    skip: (this.page - 1) * this.limit,\n                    limit: this.limit,\n                },\n                params: this.filter\n            });\n\n            this.points = points;\n            this.summary = summary;\n            this.pageCount = Math.ceil(summary.totalCount / this.limit);\n        }\n    }\n}\n<\/script>`
            }
        }
    }
    
}
</script>